module.exports = __webpack_public_path__ + "img/screen_2.897328bd.png";